const { isString } = require('bloodhound-js/lib/utils');

(function () {
    'use strict';
    const Papa = require('papaparse');


    function loadExternalScripts(onLoadCallback = null) {
        const scriptsToLoad = [
            {
                element: 'link',
                src: 'https://unpkg.com/leaflet@1.7.1/dist/leaflet.css',
                integrity: 'sha512-xodZBNTC5n17Xt2atTPuE1HxjVMSvLVW9ocqUKLsCC5CXdbqCmblAshOMAS6/keqq/sMZMZ19scR4PsZChSR7A==',
                crossorigin: 'anonymous'
            },
            {
                element: 'script',
                src: 'https://unpkg.com/leaflet@1.7.1/dist/leaflet.js',
                integrity: 'sha512-XQoYMqMTK8LvdxXYG3nZ448hOEQiglfqkJs1NOQV44cWnUrBc8PkAOcXy20w0vlaXaVUearIOBhiXZ5V3ynxwA==',
                crossorigin: 'anonymous',
                async: false,
                defer: true
            },               
            {
                element: 'script',
                src: 'https://unpkg.com/esri-leaflet@3.0.1/dist/esri-leaflet.js',
                integrity: 'sha512-JmpptMCcCg+Rd6x0Dbg6w+mmyzs1M7chHCd9W8HPovnImG2nLAQWn3yltwxXRM7WjKKFFHOAKjjF2SC4CgiFBg==',
                crossorigin: 'anonymous',
                async: false,
                defer: true
            },
            {
                element: 'script',
                src: 'https://unpkg.com/esri-leaflet-vector@3.0.0/dist/esri-leaflet-vector.js',
                integrity: 'sha512-i3LCZC/OnZR2VtZJ7ftXbZivyjPVBKeOqWuJ9SqaBnuiG18GyzTrHWYPgf1geE1LmI9yRENWSEI3jcpKx1dgqg==',
                crossorigin: 'anonymous',
                async: false,
                defer: true
            },

            {
                element: 'link',
                src: 'https://unpkg.com/leaflet-gesture-handling@1.2.2/dist/leaflet-gesture-handling.min.css',
                integrity: 'sha512-vX0FO9CCqFIE79wbaX/s/iU6YDGRtHrlVukRf4541PpIAMuQctMIkCljit1QKm3iqUnqxZ6SGC7mQ9TFM2BYJw==',
                crossorigin: 'anonymous'
            },
            {
                element: 'script',
                src: 'https://unpkg.com/leaflet-gesture-handling@1.2.2/dist/leaflet-gesture-handling.min.js',
                integrity: 'sha512-SRElYTquj3HpA/OFiOmpEXwhZUxXZAo/vBdF/5ou7jH+4oKaspceJ0l2n9s1QQMhgi4dbK+39BZXH3eeuzbWoQ==',
                crossorigin: 'anonymous',
                async: false,
                defer: true
            }
        ];

        QLD.utils.loadResources(scriptsToLoad, () => {
            if (typeof onLoadCallback === 'function') {
                onLoadCallback();
            }
        });
    }

    /**
     * @module embedMaps
     */
    var embedMaps = {};
    embedMaps.init = function () {
        /**
         * Initialise all embedded maps on a particular page
         */
        const mapEmbedElements = QLD.utils.listToArray(document.querySelectorAll('.js-map-embed-component'));
        // only process this if map elements are found
        if (mapEmbedElements.length > 0) {
            loadExternalScripts(() => {
           
                // set some defaults for when data atttribute is not set
                var initLat = -20.9175738,
                    initLong = 142.702796,
                    initZoom = 5;

                const maxBounds = [[-29.787408, 137.37628], [-10.144961, 154.729739]]; // why do we need this?

                mapEmbedElements.forEach(mapEmbedElement => {


                    const mapdata = mapEmbedElement.dataset.mapdata;
                    const mapdefaultcenter = mapEmbedElement.dataset.mapdefaultcenter; //-27.466868, 153.024951
                    const radius = parseInt(mapEmbedElement.dataset.radius, 10);
                    const custommarkers = mapEmbedElement.dataset.custommarkers;
                    const showlegend = mapEmbedElement.dataset.showlegend;
                    const customchoice = mapEmbedElement.dataset.customchoice;
                    const hidemarkers = mapEmbedElement.dataset.hidemarkers;
                    const searchresultsize = mapEmbedElement.dataset.searchresultsize;
                    const mapheight = mapEmbedElement.dataset.mapheight;
                    const mapwidth = mapEmbedElement.dataset.mapwidth;
                    const hidelabelifempty = mapEmbedElement.dataset.hidelabelifempty;
                    const autoconvertlinks = mapEmbedElement.dataset.autoconvertlinks;
                    const assetid = mapEmbedElement.dataset.assetid;
                    const websiteloc = mapEmbedElement.dataset.websiteloc;
                    const postcodeJSONURL = mapEmbedElement.dataset.postcodedata;
                    
                    if (mapdefaultcenter !== "") {
                        const latLongTemp = mapdefaultcenter.split(",");
                        initLat = parseFloat(latLongTemp[0]);
                        initLong = parseFloat(latLongTemp[1]);
                        initZoom = 17;
                    }
                    const coordinates = [parseFloat(initLat), parseFloat(initLong)];

                    const options = {
                        initialMapDataURL: mapdata,
                        initialCoordinates: coordinates, // use this if mapdefaultcenter not set
                        initialZoom: initZoom,
                        initialMaxBounds: maxBounds,
                        radius: parseInt(radius, 10),
                        useCustomMarkers: parseYesNoToBoolean(custommarkers),
                        useCustomChoice: parseYesNoToBoolean(customchoice),
                        hideLabelIfEmpty: parseYesNoToBoolean(hidelabelifempty),
                        autoConvertLinks: parseYesNoToBoolean(autoconvertlinks),
                        hideMarkers: parseYesNoToBoolean(hidemarkers),
                        searchResultSize: parseInt(searchresultsize, 10),
                        mapHeight: parseInt(mapheight, 10),
                        mapWidth: parseInt(mapwidth, 10),
                        showLegend: parseYesNoToBoolean(showlegend),
                        postcodeJSONURL: postcodeJSONURL,
                        assetId: assetid,
                    };

                    const searchableMap = new SearchableMap(mapEmbedElement, options);
                    searchableMap.initMap();
                    
                }); //mapEmbedElements.forEach         
            });

        } // end if mapEmbedElements.length
    } // end embedMaps.init()


    /**
     * Represents a searchable Leaflet map.
     * Renders a map of Qld containing location markers from a CSV list
     */
    class SearchableMap {
        /**
         * Creates an instance of the SearchableMap class.
         * @param {HTMLElement} domElement - The DOM element where the map will be rendered.
         * @param {Object} options - The options for configuring the map.
         *      @property  {string} [options.initialMapDataURL] - The URL for the CSV file containing the location details for the map.
         *      @property  {number[]} [options.initialCoordinates] - The initial coordinates [latitude, longitude] of the map center.
         *      @property  {number} [options.initialZoom] - The initial zoom level of the map.
         *      @property  {[number[],number[]]} [options.initialMaxBounds] - The initial bounds of the map [[southwestLatitude, southwestLongitude], [northeastLatitude, northeastLongitude]].
         *      @property  {boolean} [options.useCustomMarkers] - Whether to use custom markers for map points.
         *      @property  {boolean} [options.useCustomChoice] - Whether to select what marker should be used for what category.
         *      @property  {boolean} [options.hideLabelIfEmpty] - Whether to hide labels if they are empty.
         *      @property  {boolean} [options.autoConvertLinks] - Whether to automatically convert links in popup content.
         *      @property  {boolean} [options.hideMarkers] - Whether to hide markers on the map.
         *      @property  {boolean} [options.showLegend] - Whether to show a legend alongside the map.
         *      @property  {string} [options.postcodeJSONURL] - The URL for the postcode data.
         *      @property  {string} [options.assetid] - The asset ID associated with the map.
         *      @property  {string} [options.websiteLoc] - The location of the website associated with the map.
         */
        constructor(domElement, options) {
            this.domElement = domElement;
            this.options = options;
            this.map = null;    // stores the leaflet map object
            this.markerLayer = L.layerGroup(); // all markers
            this.visibleMarkers = [],
            this.finalCategories = [],
            this.maxCategories = 7,
            this.labels = [],
            this.locations = [],    // stores the CSV locations
            this.mapBounds = null,
            this.errorString = '',
            this.predefinedCount = 0,
            this.postcodeJSON = [];

            const loadPostcodes = async function(url) {
                const response = await fetch(url);
                const postcodeJSON = await response.json();
                return postcodeJSON;
            };
            loadPostcodes(this.options.postcodeJSONURL)
                .then(postcodeJSON => {
                    this.postcodeJSON = postcodeJSON;
                })
                .catch(error => {
                    console.error('Error:', error);
                });


            this.markerImageArray = [
                { "icon": "briefcase", "url": "data:image/png;base64,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" },
                { "icon": "building", "url": "data:image/png;base64,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" },
                { "icon": "building2", "url": "data:image/png;base64,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" },
                { "icon": "building3", "url": "data:image/png;base64,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" },
                { "icon": "clipboard", "url": "data:image/png;base64,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" },
                { "icon": "computer", "url": "data:image/png;base64,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" }                
            ];
        }

        convertLinks(linkToConvert) {
            if (this.options.autoConvertLinks) {
                return linkToConvert.replace(/((http|https)\:\/\/[a-zA-Z0-9\-\.\_]+\.[a-zA-Z]{2,3}(\/\S*)?)/g, `<a href="$1">$1</a>`);
            } else {
                return linkToConvert;
            }
        }

        getIcon(results, i, customMarkerChoice) {
            var v = results.meta["fields"].length;
            let catTempResult, markerTempResult;
            if (customMarkerChoice === true) {
                catTempResult = results.data[i][results.meta["fields"][v - 2]];
                markerTempResult = results.data[i][results.meta["fields"][v - 1]].toLowerCase();
                if (catTempResult == "" || markerTempResult == "") {
                    this.errorHandler("-3");
                }
                markerTempResult = this.checkAndUpdateFinalCategories(catTempResult, markerTempResult, false);
            } else {
                catTempResult = results.data[i][results.meta["fields"][v - 1]];
                markerTempResult = this.checkAndUpdateFinalCategories(catTempResult, "", true);
            }
            return markerTempResult;
        }

        checkAndUpdateFinalCategories(catTempResult, markerTempResult, predefined) {
            var iconToUse = "";

            if (this.finalCategories.length == 0) {
                this.finalCategories.push({
                    "category": catTempResult,
                    "icon": predefined ? this.markerImageArray[this.predefinedCount].icon : markerTempResult
                });
                if (predefined) {
                    iconToUse = this.markerImageArray[this.predefinedCount].icon;
                    this.predefinedCount++;
                } else {
                    iconToUse = markerTempResult;
                }
            } else {
                var custMarkerHit = false;
                for (var t = 0; t < this.finalCategories.length; t++) {
                    if (catTempResult == this.finalCategories[t].category) {
                        custMarkerHit = true;
                        iconToUse = this.finalCategories[t].icon;
                    }
                }
                if (!custMarkerHit) {
                    if (this.finalCategories.length < this.maxCategories) {
                        this.finalCategories.push({
                            "category": catTempResult,
                            "icon": predefined ? this.markerImageArray[this.predefinedCount].icon : markerTempResult
                        });
                        if (predefined) {
                            iconToUse = this.markerImageArray[this.predefinedCount].icon;
                            this.predefinedCount++;
                        } else {
                            iconToUse = markerTempResult;
                        }
                    } else {
                        this.errorHandler("-1");
                    }
                }
            }
            return iconToUse;
        }

        // set up listeners for search form and reset
        initEventListeners() {
            const containerElement = this.getContainerElement();
            const mapSearchForm = containerElement.querySelector('.qld__maps-search-form');
            const searchField = mapSearchForm.querySelector('input[name="p"]');
            const self = this;
           
            if (mapSearchForm) {
                mapSearchForm.addEventListener("submit", function (event) {
                    event.preventDefault();
                   
                    if (searchField.value == "") {
                        self.resetMap();
                        return false;
                    } else {
                        self.geoCoder();
                    }
                   
                });

                // reset button event listener
                const resetField = mapSearchForm.querySelector('button.qld__btn--reset');
                if (resetField) {
                    resetField.addEventListener("click", function (event) {
                        self.resetMap();
                    });
                }              
            }

        }
 
        initMap() {
            var locations = [],
                labels = [],
                errorString = '';

            var self = this;

            // process the map csv data
            var papaConfig = {
                quoteChar: '"',
                escapeChar: '"',
                skipEmptyLines: 'greedy',
                header: true,
                download: true,
                complete: function (results, file) {
                   
                    for (var i = 0; i < results.meta["fields"].length; i++) {
                        labels.push(results.meta["fields"][i]);
                    }
                    self.labels = labels;
                    for (var i = 0; i < results.data.length; i++) {
                        const popupListItems = [];
                        for (var v = 4; v < results.meta["fields"].length; v++) {
                            results.data[i]["Title"] = results.data[i]["Title"].replace(/[^a-zA-Z0-9() ]/g,'-');
                            if ((self.options.hideLabelIfEmpty !== true) || (results.data[i][results.meta["fields"][v]] != "")) {
                                if (/^(?!icon$|category$)/i.test(results.meta["fields"][v])) {
                                    popupListItems.push("<li><label>" + results.meta["fields"][v] + ":</label> " + self.convertLinks(results.data[i][results.meta["fields"][v]]) + "</li>");
                                }
                            }
                        }
                        const popupContent = `<div class="pin-content">
    <h4>${results.data[i][results.meta["fields"][0]]}</h4>
    <ul class="qld__link-list">${popupListItems.join('')}</ul>
</div>`;
                        if (self.options.useCustomMarkers) {
                            const icon = self.getIcon(results, i, self.options.useCustomChoice);
                            self.locations.push([popupContent, results.data[i][results.meta["fields"][1]], results.data[i][results.meta["fields"][2]], results.data[i], icon]);
                        } else {
                            self.locations.push([popupContent, results.data[i][results.meta["fields"][1]], results.data[i][results.meta["fields"][2]], results.data[i]]);
                        }
                    }

                    self.createMap();
                    self.initEventListeners();

                    if (self.errorString.length > 0) {
                        const errorHTML = `<div class="qld__page-alerts qld__page-alerts--error">
<div class="qld__page-alerts--heading qld__display-lg">Maps CSV file error</div>
<div><p>${self.errorString}</p></div>
</div>`;
                        self.clearSearchResults();
                        const legendElement = self.getContainerElement().querySelector('.qld__maps-legend');
                        if (legendElement) {
                            legendElement.remove();
                        }
                        self.domElement.innerHTML = errorHTML;
                        self.domElement.style.minHeight = '100px';
                        self.domElement.style.backgroundColor = '#FFFFFF';
                    }   
                }
            }

            Papa.parse(this.options.initialMapDataURL, papaConfig);
        }
        
        /**
         * Creates the Leaflet map object and initializes it with the provided options.
         */
        createMap() {
            const {
                initialCoordinates,
                initialZoom,
                useCustomMarkers,
                hideMarkers,
                showLegend,
                mapHeight,
                mapWidth
            } = this.options;

            if(mapHeight){
                this.domElement.style.minHeight = `${mapHeight}px`;
            }            
            if(mapWidth){
                this.domElement.style.width = `${mapWidth}px`;
            }



            this.map = L.map(this.domElement, {gestureHandling: true}).setView(initialCoordinates, initialZoom);

            //this.map.setMaxBounds(initialMaxBounds);     // i don't think we should have maxbounds       
            this.mapBounds = this.map.getBounds();

            this.map.zoomControl.setPosition('bottomright');

            L.esri.Vector.vectorBasemapLayer('ArcGIS:Topographic', {
                apiKey:
                    'AAPK14c2db245cb5432da99353b71b6433dflik7DtfBuaNdb8nB-MjrF9DiaBOQkhlWuu0asMWlyHxAitjLsCJRPXPBU5blMVGr',
            }).addTo(this.map);

            // original map
                        // L.esri.tiledMapLayer({
                        //     //url: 'https://spatial-gis.information.qld.gov.au/arcgis/rest/services/Basemaps/QldBase_Colour/MapServer',
                        //     minZoom: 5
                        // })




            // Check if markers should be hidden
            if (hideMarkers) {
                this.map.setZoom(initialZoom);
                this.addMarkers(hideMarkers);
            } else {
                // add markers to map
                this.addMarkers();
                let params = new URLSearchParams(window.location.search);
                let search = params.get("search");
                if (search) {
                    const searchField = this.getContainerElement().querySelector('input[name="p"]');
                    if (searchField) {
                        searchField.value = search;
                    }
                    this.geoCoder(search);
                } 
            }


            // custom markers
            if ((showLegend) && (useCustomMarkers)) {
                this.createMapLegend();
            }

        }

        getContainerElement() {
            return this.domElement.closest('.qld__maps__container');
        }
        getWrapperElement() {
            return this.domElement.closest('.qld__maps__wrapper');
        }
        getSearchResultsElement() {
            return this.getContainerElement().querySelector('.qld__maps__search_results');
        }

        createMapLegend() {
            let matchFound = 0;
            let legendHTML = '', legendList = '';

            var fc = this.finalCategories;
            for (var g = 0; g < this.finalCategories.length; g++) {
                matchFound = 0;

                for (var h = 0; h < this.markerImageArray.length; h++) {
                    if (this.markerImageArray[h].icon == this.finalCategories[g].icon) {
                        legendList += `<li><img src="${this.markerImageArray[h].url}" class="qld__icon qld__icon--lg qld__icon--lead">${this.finalCategories[g].category}</li>`;
                        matchFound = 1;
                    }
                }
                if (matchFound == 0) {
                    this.errorHandler("-2");
                    return false;
                }
            }
            if (legendList.length > 0) {
                legendHTML = `<div class="qld__maps-legend qld__card">
                                <div class="qld__card__inner">
                                    <div class="qld__card__content">
                                        <div class="qld__card__content-inner">
                                            <p><strong>Map symbols</strong></p>
                                            <ul class="qld__link-list">${legendList}</ul>
                                        </div>
                                    </div>
                                </div>
                            </div>`;
                this.domElement.insertAdjacentHTML('afterEnd', legendHTML);
                window.dispatchEvent(new Event('resize'));
            }
            return true;
        }

        resetMap() {
            this.clearSearchResults();
            this.clearLayers();
            this.addMarkers();
        }

        paginate(searchResultsElement) {
            const resultItems = searchResultsElement.querySelectorAll('li');
            const numResults = resultItems.length;
            const searchResultSize = this.options.searchResultSize;

            if (searchResultSize > 0 && numResults > searchResultSize) {
                const numPages = Math.ceil(numResults / searchResultSize);
                this.buildPagination(searchResultsElement, 1, numPages, searchResultSize);
            }
        }

        buildPagination(searchResultsElement, currentPage, numPages, searchResultSize) {
            const createPaginationItem = (pageNumber) => {
                const activeClass = (currentPage == pageNumber) ? ' active' : '';
                return `<li class="mid${activeClass}"><a href="#" data-page="${pageNumber}">${pageNumber}</a></li>`;
            };
            const createPaginationEllipsis = () => {
                return `<li class="ellipsis"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" aria-hidden="true" focusable="false" width="24" height="32" role="img"><path fill="currentColor" d="M352 256C352 238.3 366.3 224 384 224C401.7 224 416 238.3 416 256C416 273.7 401.7 288 384 288C366.3 288 352 273.7 352 256zM192 256C192 238.3 206.3 224 224 224C241.7 224 256 238.3 256 256C256 273.7 241.7 288 224 288C206.3 288 192 273.7 192 256zM96 256C96 273.7 81.67 288 64 288C46.33 288 32 273.7 32 256C32 238.3 46.33 224 64 224C81.67 224 96 238.3 96 256z"></path></svg></li>`;
            };

            const self = this;
            const paginationElement = searchResultsElement.querySelector('.qld__search-pagination');
            const resultsListElement = searchResultsElement.querySelector('.qld__search__results-list');
            if (paginationElement) {
                paginationElement.remove();
            }
            const liElements = resultsListElement.querySelectorAll('li');
            liElements.forEach(li => li.classList.add('hidden'));

            const n = (currentPage - 1) * searchResultSize;
            resultsListElement.setAttribute("start", n + 1);


            const el = searchResultsElement;
            if (n > 0) {
                for (let i = 0; i < liElements.length; i++) {
                    if (i >= n && i < n + searchResultSize) {
                        liElements[i].classList.remove("hidden");
                    }
                }
            } else {
                for (let i = 0; i < searchResultSize; i++) {
                    liElements[i].classList.remove("hidden");
                }
            }

            const pagePadding = 2;
            const paginationItems = [];
            const startPage = Math.max(2, currentPage - pagePadding);
            const endPage = Math.min(numPages - 1, currentPage + pagePadding);

            if (currentPage > 1) {
                paginationItems.push(`<li class="prev"><a class="qld__search-pagination_link" href="#" data-page="${(currentPage - 1)}" rel="prev" aria-label="Previous page of results"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" aria-hidden="true" focusable="false" width="16" height="16" role="img"><path fill="currentColor" d="M448 256C448 264.8 440.6 272 431.4 272H54.11l140.7 149.3c6.157 6.531 5.655 16.66-1.118 22.59C190.5 446.6 186.5 448 182.5 448c-4.505 0-9.009-1.75-12.28-5.25l-165.9-176c-5.752-6.094-5.752-15.41 0-21.5l165.9-176c6.19-6.562 16.69-7 23.45-1.094c6.773 5.938 7.275 16.06 1.118 22.59L54.11 240h377.3C440.6 240 448 247.2 448 256z"/></svg><span>Back</span></a></li>`);
            }
            paginationItems.push(createPaginationItem(1));
            if (startPage - 1 > 1) {
                paginationItems.push(createPaginationEllipsis());
            }
            for (let i = startPage; i <= Math.min(numPages - 1, endPage); i++) {
                paginationItems.push(createPaginationItem(i));
            }
            if ((numPages - endPage) > 1) {
                paginationItems.push(createPaginationEllipsis());
            }
            paginationItems.push(createPaginationItem(numPages));
            if (currentPage < numPages) {
                paginationItems.push(`<li class="next"><a class="qld__search-pagination_link" href="#" data-page="${(currentPage + 1)}" rel="next" aria-label="Next page of results"><span>Next</span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" aria-hidden="true" focusable="false" width="16" height="16" role="img"><path fill="currentColor" d="M443.7 266.8l-165.9 176C274.5 446.3 269.1 448 265.5 448c-3.986 0-7.988-1.375-11.16-4.156c-6.773-5.938-7.275-16.06-1.118-22.59L393.9 272H16.59c-9.171 0-16.59-7.155-16.59-15.1S7.421 240 16.59 240h377.3l-140.7-149.3c-6.157-6.531-5.655-16.66 1.118-22.59c6.789-5.906 17.27-5.469 23.45 1.094l165.9 176C449.4 251.3 449.4 260.7 443.7 266.8z"/></svg></a></li>`);
            }

            const paginationHTML = `<nav class="text-center hidden-print qld__search-pagination" aria-label="pagination">
    <h2 class="sr-only">Pagination</h2>
    <ul class="qld__search-pagination__list">${paginationItems.join('')}</ul>
</nav>`;

            searchResultsElement.insertAdjacentHTML('beforeend', paginationHTML);

            const paginationLinks = searchResultsElement.querySelectorAll('.qld__search-pagination a'); // Replace with your actual selector

            paginationLinks.forEach(link => {
                link.addEventListener('click', event => {
                    event.preventDefault();
                    const page = parseInt(link.getAttribute('data-page'));
                    self.buildPagination(searchResultsElement, page, numPages, searchResultSize);
                    searchResultsElement.scrollIntoView();
                });
            });
        }


        /**
         * Builds the HTML search results list based on the provided results array.
         *
         * @param {Array} results - The array of search results to be displayed.
         */
        buildSearchResults(results) {
            const searchResultsElement = this.getSearchResultsElement();
            const labels = this.labels;
            const filteredLabels = labels.filter(label => !/^(icon|category)$/i.test(label));
            const self = this;
    
            if (searchResultsElement) {
             
                let searchResultItems = [];
                let title;
                results.forEach(function (val) {
                  
                    title = val[3][labels[0]];
                    let searchResultItemLabels = [];
                    const distanceHTML = val[3].dist ? ` (${val[3].dist.toFixed(2)} km)` : ''; 
                    let searchResultItemHeaderHTML = `<div class="qld__search__result-header"><div class="qld__search__result-title"><a class="view-map" data-lat="${val[3][labels[1]]}" data-long="${val[3][labels[2]]}" href="#">${title}</a></div></div>`;
                    for (var i = 4; i < labels.length; i++) {
                        if ((self.options.hideLabelIfEmpty !== true) || (val[3][labels[i]] != "")) {
                            if (/^(?!icon$|category$)/i.test(labels[i])) {
                                searchResultItemLabels.push(`<strong>${labels[i]}:</strong> ${self.convertLinks(val[3][labels[i]])}`);
                            }
                        }

                    }
                    let labelsHTML = searchResultItemLabels.join('<br>');
                    
                    let searchResultItemHTML = `<li class="qld__search__result">
<div class="qld__search__result-inner">${searchResultItemHeaderHTML}</div>
<p class="qld__search__result-summary">${labelsHTML}</p>
</li>`;
                    searchResultItems.push(searchResultItemHTML);

                });

                if (searchResultItems.length > 0) {
                    const searchResultItemsHTML = searchResultItems.join('');
                    const searchResultsHTML = `<ol class="qld__link-list qld__search__results-list">${searchResultItemsHTML}</ol>`;
                    searchResultsElement.innerHTML = searchResultsHTML;
                    const viewMapLinks = searchResultsElement.querySelectorAll('a.view-map');

                    viewMapLinks.forEach(link => {
                        link.addEventListener('click', function (event) {
                            event.preventDefault();
                            const lat = parseFloat(this.dataset.lat);
                            const long = parseFloat(this.dataset.long);
                            const scrollPos = self.domElement.getBoundingClientRect().top + window.scrollY - 20;
                            
                            window.scrollTo({
                                top: scrollPos,
                                behavior: 'smooth'
                            });

                            self.centerMapOnLatLng([lat, long]);
                        });
                    });

                    this.paginate(searchResultsElement);
                }
            }
        }

        /**
         * Fits the map's view to the bounds containing the specified visible markers.
         *
         * @param {L.Marker[]} visibleMarkers - An array of visible markers to fit the map bounds to.
         */
        fitMapBounds(visibleMarkers) {
            // Ensure there's at least one visible Marker
            if (visibleMarkers.length > 1) {
                // Create bounds from first Marker then extend it with the rest
                const markersBounds = L.latLngBounds(visibleMarkers[0].getLatLng());
                visibleMarkers.forEach((marker) => {
                    markersBounds.extend(marker.getLatLng());
                });

                // Fit the map with the visible markers bounds
                this.map.flyToBounds(markersBounds, {
                    padding: L.point(36, 36),
                    animate: true,
                    duration: 1
                });
            } else if (visibleMarkers.length == 1) {
                this.centerMapOnLatLng(visibleMarkers[0].getLatLng());
            }
        }

        /**
         * Centers the map on the specified LatLng and sets the zoom level.
         *
         * @param {L.LatLng} latLng - The LatLng to center the map on.
         * @param {number} [zoomLevel=17] - The zoom level to set for the map.
         */
        centerMapOnLatLng(latLng, zoomLevel = 17) {
            this.map.flyTo(latLng, zoomLevel, {
                animate: true,
                duration: 1
            });
        }


        processResults(from, postcode = null) {
            const self = this;
            const visibleMarkers = [];
            const results = [];
            const addResult = (val, useCustomMarkers, results, visibleMarkers) => {
                const result = useCustomMarkers
                  ? [val[0], val[1], val[2], val[3], val[4]]
                  : [val[0], val[1], val[2], val[3]];
              
                results.push(result);
                visibleMarkers.push(val[3].marker);
              };
              
            self.locations.forEach(function (val, key) {
                if (!isNaN(val[1]) && !isNaN(val[2])) {
                    var to = L.latLng(parseFloat(val[1]), parseFloat(val[2]));
                    var distance = from.distanceTo(to);
                    // Include all matching postcodes regardless of distance plus any locations that fall within the specified radius
                    if ((val[3].Postcode == postcode) || (distance / 1000 < self.options.radius) ) {
                        val[3].dist = distance / 1000;
                        addResult(val, self.options.useCustomMarkers, results, visibleMarkers);
                    }
                }
            });

            self.visibleMarkers = visibleMarkers;
            if (results.length > 0) {
                results.sort(function (a, b) {
                    return a[3].dist - b[3].dist;
                });

                const boundMarkers = results.slice(0, 5).map((val) => L.marker([val[1], val[2]]));
                self.buildSearchResults(results);
                self.fitMapBounds(boundMarkers);
                self.displayMarkers();
                return true;
            } else {
                return false;
            }
        }

        geoCoder(queryStr = null) {
            var apiFallBack = true;
            const self = this;
            const mapContainerElement = this.getContainerElement();
            const searchInput = mapContainerElement.querySelector('input[name="p"]');
            const radiusField = mapContainerElement.querySelector('select[name="distance"]');
            const searchResultsElement = this.getSearchResultsElement();
            const query = queryStr ? queryStr : searchInput.value;
            this.gaTracker(query);
            if (radiusField.value != "") {
                self.options.radius = parseInt(radiusField.value, 10);
            }
            const noResultsMsg = `<div class="qld__search__result qld__input--error">
                                    <p>Your search did not return any results within ${self.options.radius}km of the location that you specified. Please try a different location.</p>
                                </div>`;
            const localPostcodes = this.postcodeJSON;            
            const placeFound = localPostcodes.filter(function (el) {     
                if (isNaN(query)) {
                    return el['suburb'].toLowerCase() === query.toLowerCase();
                } else {
                    return el['postcode'].includes(query);

                }
            });
            
                
            
            if (placeFound.length > 0) {
                const from = L.latLng(placeFound[0].lat, placeFound[0].lng);
                if (this.processResults(from, query)) {
                    apiFallBack = false;
                    searchInput.classList.remove("qld__text-input--error");
                }
            } else {
                searchInput.classList.add("qld__text-input--error");
                searchResultsElement.innerHTML = noResultsMsg;
            }
               
            /** Works if Google API has been added */
            function performGeocoding(query){
                if (typeof google !== 'undefined' && typeof google.maps !== 'undefined') {
                    const geocoder = new google.maps.Geocoder();
                    geocoder.geocode({ 'address': query + '+queensland+australia' }, function (resp, status) {
                        if (status == 'OK') {
                            if (resp[0]) {                            
                                if ((resp[0].geometry.location.lat() == "-20.9175738") && (resp[0].geometry.location.lng() == "142.7027956")) {
                                    // No results, Google Maps is just showing you the location of Queensland.
                                    searchResultsElement.innerHTML = noResultsMsg;
                                } else {
                                    const from = L.latLng(resp[0].geometry.location.lat(), resp[0].geometry.location.lng());
                                    if (!self.processResults(from)) {
                                        searchResultsElement.innerHTML = noResultsMsg;
                                    }
                                }
                            } else {
                                searchResultsElement.innerHTML = noResultsMsg;
                            }
                        } else {
                            searchResultsElement.innerHTML = `<div class="qld__search__result"><p>Google Geocoder failed due to: ${status}</p></div>`;
                        }
                    });
                }
            }

            if (apiFallBack == true) {
                if (typeof google !== 'undefined' && typeof google.maps !== 'undefined') {
                    performGeocoding(query);
                } else {
                    loadExternalScripts(() => {
                        performGeocoding(query);
                    });
                }

            }

        }

        gaTracker(query) {
            // GTM event
            if (typeof (window.dataLayer) !== 'undefined') {
                window.dataLayer.push({
                    event: 'interaction',
                    category: 'ng maps - ' + this.options.websiteLoc + " - " + this.options.assetId,
                    action: 'search',
                    label: query
                });
            }
        }


        /**
         * Adds markers to the map from using the object locations marker coordinates.
         */
        addMarkers(hideMarkers = false) {
            var matchFound = 0,
                maxExtendBounds = 0;
            let markerDetails = this.locations;
            const visibleMarkers = [];
            if (this.options.useCustomMarkers) {
                for (var i = 0; i < markerDetails.length; i++) {
                    let iconName = markerDetails[i][markerDetails[i].length - 1];
                    let newMarker;
                    for (var h = 0; h < this.markerImageArray.length; h++) {
                        if (this.markerImageArray[h].icon == iconName) {
                            newMarker = L.icon({
                                iconUrl: this.markerImageArray[h].url,
                                iconSize: [30, 38],
                                shadowSize: [30, 38],
                                iconAnchor: [15, 38],
                                popupAnchor: [1, -38]
                            });
                            matchFound = 1;
                        }
                    }
                    if (matchFound == 0) {
                        this.errorHandler("-2");
                        return false;
                    }

                    const marker = L.marker([markerDetails[i][1], markerDetails[i][2]], { icon: newMarker }).bindPopup(markerDetails[i][0]);
                    this.locations[i][3].marker = marker;
                    marker.addTo(this.markerLayer);
                    visibleMarkers.push(marker);
                    this.mapBounds.extend([markerDetails[i][1], markerDetails[i][2]]);
                }
            } else {
                // not using custom markers...
                for (var i = 0; i < markerDetails.length; i++) {
                    const marker = L.marker([markerDetails[i][1], markerDetails[i][2]]).bindPopup(markerDetails[i][0]);
                    this.locations[i][3].marker = marker;
                    marker.addTo(this.markerLayer);
                    visibleMarkers.push(marker);
                    this.mapBounds.extend([markerDetails[i][1], markerDetails[i][2]]);
                }

            }
            this.visibleMarkers = visibleMarkers;

            if (markerDetails.length == 1) {
                this.map.setView([parseFloat(markerDetails[0][1]), parseFloat(markerDetails[0][2])], 17);
            } else {
                this.map.fitBounds(this.mapBounds);
            }
            
            if(!hideMarkers){
                this.displayMarkers();
            }
            
        }

        clearLayers(){
            const self = this;
            this.map.eachLayer(function (layer) {
                if (layer instanceof L.Marker) {
                    self.map.removeLayer(layer);
                }
            });

        }

        clearSearchResults(){
            const searchResultsElement = this.getSearchResultsElement();
            const searchField = this.getContainerElement().querySelector('input[name="p"]');
            searchResultsElement.innerHTML = '';
            searchField.classList.remove("qld__text-input--error");
        }

        displayMarkers() {
            this.clearLayers();
            const visibleMarkers = this.visibleMarkers;
            const visibleLayer = L.layerGroup(); 
            visibleMarkers.forEach(marker => {
                marker.addTo(visibleLayer);
            });
            
            // Add the visible layer to the map
            this.map.addLayer(visibleLayer);

        }

        errorHandler(errorType) {
            let errorString = '';
            switch (errorType) {
                case "-1": errorString = "More than 7 different categories were detected in the CSV file! <br>Please reduce the number of different categories in the CSV file to 7 or less.";
                    break;
                case "-2": errorString = "Invalid custom marker icon name encountered. <br>Make sure all icons names are valid and also check the spelling in the CSV file.";
                    break;
                case "-3": errorString = "One of the rows in your CSV does not have an icon assigned to it. <br>Please check the 2nd last column in the CSV file and make sure an icon is assigned to every row.";
                    break;
                case "-4": errorString = "Too many search results to display, please be more sepcific with the address that you are trying to search for.";
                    break;
                case "-5": errorString = "There were zero results returned for your search.";
                    break;
                case "-6": errorString = "There was an issue with the search functionality, please try and search again later.";
            }
            this.errorString = errorString;
        }

    }

    /**
     * Parses a string input and returns a boolean value. Useful for Metadata fields that use Yes,No as their values.
     * @param {string} input - The input string to be parsed.
     * @returns {boolean} - Returns true if input is "yes" (case-insensitive), false otherwise.
     */
    const parseYesNoToBoolean = (input) => /^yes$/i.test(input);


    QLD.embedMaps = embedMaps;

    document.addEventListener('DOMContentLoaded', function (e) {
        QLD.embedMaps.init();
    });

    // const input = document.querySelector('input[name="p"]');;
    // const suggestionsContainer = document.getElementById('autocomplete-suggestions');

    // input.addEventListener('input', function() {
    //     const query = this.value.toLowerCase();
    //     suggestionsContainer.innerHTML = '';

    //     if (query) {
    //         const filteredData = data.filter(item => item.name.toLowerCase().includes(query));
    //         filteredData.forEach(item => {
    //             const suggestion = document.createElement('div');
    //             suggestion.classList.add('autocomplete-suggestion');
    //             suggestion.textContent = item.name;
    //             suggestion.addEventListener('click', function() {
    //                 input.value = item.name;
    //                 suggestionsContainer.innerHTML = '';
    //             });
    //             suggestionsContainer.appendChild(suggestion);
    //         });
    //     }
    // });

}());